import SelectMultiSearch from '../../Core/Fields/Floating/SelectMultiSearch';
import SelectSearch from '../../Core/Fields/Floating/SelectSearch';
import { useGetWarehouseListMutation } from '../../store/api/purchaseorderapi';
import { useEffect, useState } from 'react';

const Tab1 = ({ formData, handleChange, errors, cartBinOptions, setCartBinOptions, BulkcartBinOptions, setBulkCartBinOptions }) => {
  const [warehouseList, setWarehouseList] = useState([]);
  const [getWarehouseData] = useGetWarehouseListMutation();


  const handlselectedwarehouseChange = (newware) => {
    setCartBinOptions(newware);
  };
  const handlselectedbULKwarehouseChange = (newware) => {
    setBulkCartBinOptions(newware);
  };
  const warehouseOptions = warehouseList.map(warehouse => ({
    label: warehouse.name,
    value: warehouse.name
  }));

  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        const response = await getWarehouseData().unwrap();
        setWarehouseList(response?.result || []);
      } catch (error) {
        console.error('Error fetching warehouse list:', error);
      }
    };
    fetchWarehouses();
  }, [getWarehouseData]);

  const handlewarehouseeserch = (search) => {
    console.log("search Delivery search:", search);


  };
  return (
    <>
      <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>

        {/* Checkboxes Row */}
        <div className="col-3">
          <div className="mb-3 ">
            <input
              type="checkbox"
              checked={formData.packingSlipRequired || false}
              className="form-check-input"
              style={{ backgroundColor: '#FFFFF', borderColor: '#270b79' }}
              onChange={() => handleChange('packingSlipRequired', !formData.packingSlipRequired)}
            />
            <label style={{ fontSize: '0.9rem', position: 'relative', top: '-1px', paddingLeft: '5px', color: '#00000099' }}>
              Packing Slip Required
            </label>
          </div>
        </div>

        <div className="col-3">
          <div className="mb-3 ">
            <input
              type="checkbox"
              checked={formData.allowPicklistCreation || false}
              className="form-check-input"
              style={{ backgroundColor: '#FFFFF', borderColor: '#270b79' }}
              onChange={() => handleChange('allowPicklistCreation', !formData.allowPicklistCreation)}
            />
            <label style={{ fontSize: '0.9rem', position: 'relative', top: '-1px', paddingLeft: '5px', color: '#00000099' }}>
              Allow Picklist Creation In Stock Shortage
            </label>
          </div>
        </div>

        <div className="col-3">
          <div className="mb-3 ">
            <input
              type="checkbox"
              checked={formData.gateEntry || false}
              className="form-check-input"
              style={{ backgroundColor: '#FFFFF', borderColor: '#270b79' }}
              onChange={() => handleChange('gateEntry', !formData.gateEntry)}
            />
            <label style={{ fontSize: '0.9rem', position: 'relative', top: '-1px', paddingLeft: '5px', color: '#00000099' }}>
              Gate Entry Required
            </label>
          </div>
        </div>


        {/* <div className="mb-3 ">
          <input
            type="checkbox"
            checked={formData.shipment_with_invoice || false}
            className="form-check-input"
            style={{ backgroundColor: '#FFFFF', borderColor: '#270b79' }}
            onChange={() => handleChange('shipment_with_invoice', !formData.shipment_with_invoice)}
          />
          <label style={{ fontSize: '0.9rem', position: 'relative', top: '-1px', paddingLeft: '5px', color: '#00000099' }}>
            Shipment With Invoice
          </label>
        </div>

                <div className="mb-3 ">
          <input
            type="checkbox"
            checked={formData.shipment_without_invoice || false}
            className="form-check-input"
            style={{ backgroundColor: '#FFFFF', borderColor: '#270b79' }}
            onChange={() => handleChange('shipment_without_invoice', !formData.shipment_without_invoice)}
          />
          <label style={{ fontSize: '0.9rem', position: 'relative', top: '-1px', paddingLeft: '5px', color: '#00000099' }}>
            Shipment With Out Invoice
          </label>
        </div> */}

        {/* First Row of Select Fields */}
        <div className="col-4">
          <div className="mb-3">
            <SelectSearch
              list={warehouseList}
              label="Default Purchase Bin"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={formData.defaultPurchaseBin || ''}
              onChange={(val) => handleChange('defaultPurchaseBin', val)}
              error={errors?.defaultPurchaseBin}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <SelectSearch
              list={warehouseList}
              label="Default Rejected Bin"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={formData.defaultRejectedBin || ''}
              onChange={(val) => handleChange('defaultRejectedBin', val)}
              error={errors?.defaultRejectedBin}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <SelectSearch
              list={warehouseList}
              label="Default Purchase Return Bin"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={formData.defaultPurchaseReturn || ''}
              onChange={(val) => handleChange('defaultPurchaseReturn', val)}
              error={errors?.defaultPurchaseReturn}
            />
          </div>
        </div>

        {/* Second Row of Input Fields */}
        <div className="col-3">
          <div className="mb-3">

            <SelectSearch
              list={warehouseList}
              label="Default Mfg From Bin"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={formData.defaultMfgFromBin || ''}
              onChange={(val) => handleChange('defaultMfgFromBin', val)}
              error={errors?.defaultMfgFromBin}
            />
          </div>
        </div>

        <div className="col-3">
          <div className="mb-3">


            <SelectSearch
              list={warehouseList}
              label="Default Mfg To Bin"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={formData.defaultMfgToBin || ''}
              onChange={(val) => handleChange('defaultMfgToBin', val)}
              error={errors?.defaultMfgToBin}
            />
          </div>
        </div>

        <div className="col-3">
          <div className="mb-3">
            <SelectSearch
              list={warehouseList}
              label="Default RGP Shipment Bin"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={formData.defaultRGPShipment || ''}
              onChange={(val) => handleChange('defaultRGPShipment', val)}
              error={errors?.defaultRGPShipment}
            />
          </div>
        </div>

        <div className="col-3">
          <div className="mb-3">
            <SelectSearch
              list={warehouseList}
              label="Default RGP Receipt Bin"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={formData.defaultRGPReceipt || ''}
              onChange={(val) => handleChange('defaultRGPReceipt', val)}
              error={errors?.defaultRGPReceipt}
            />
          </div>
        </div>

        {/* Third Row of Select Fields */}
        <div className="col-4">
          <div className="mb-3">
            <SelectSearch
              list={warehouseList}
              label="Default Sales Return Bin"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={formData.defaultSalesReturn || ''}
              onChange={(val) => handleChange('defaultSalesReturn', val)}
              error={errors?.defaultSalesReturn}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">

            <SelectMultiSearch
              label="B2B Bin"
              options={warehouseOptions}
              value={cartBinOptions}
              onSearch={handlewarehouseeserch}
              onChange={handlselectedwarehouseChange}
            // onRemove={handlesalesInvoiceRemove}

            />
          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">
            {/* <SelectSearch
              list={warehouseList}
              label="Bulk Order Bin"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={formData.bulkOrderBin || ''}
              onChange={(val) => handleChange('bulkOrderBin', val)}
              error={errors?.bulkOrderBin}
            /> */}
            <SelectMultiSearch
              label="Bulk Order Bin"
              options={warehouseOptions}
              value={BulkcartBinOptions}
              onSearch={handlewarehouseeserch}
              onChange={handlselectedbULKwarehouseChange}
            // onRemove={handlesalesInvoiceRemove}

            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Tab1;